import { NBSP_CODE as c } from "./index.es5554.js";
const a = (n) => {
  const o = n.split(" ");
  if (o.length > 1) {
    const e = o[o.length - 2].length === 1, t = o.length > 2 && e ? -3 : -2, r = o.slice(t).join(c), s = o.slice(0, t).join(" ");
    return s + (s ? " " : "") + r;
  }
  return n;
};
export {
  a as addNonBreakingSpaces
};
//# sourceMappingURL=index.es2446.js.map
